export enum Role {
  AI_USER = 'AI_USER',
  BANK_ID = 'BANK_ID',
  BACKOFFICE_ADMIN = 'BACKOFFICE_ADMIN',
  BACKOFFICE_SWAGGER = 'BACKOFFICE_SWAGGER',
  BANK_ACCOUNT_IFRAME = 'BANK_ACCOUNT_IFRAME',
  BANK_ACCOUNT_READ = 'BANK_ACCOUNT_READ',
  BANK_ACCOUNT_WRITE = 'BANK_ACCOUNT_WRITE',
  BANK_FILE_READ = 'BANK_FILE_READ',
  BANK_FILE_WRITE = 'BANK_FILE_WRITE',
  CLOUD_POS_ACCESS = 'CLOUD_POS_ACCESS',
  CLOUD_POS_ADMIN = 'CLOUD_POS_ADMIN',
  CUSTOMER_READ = 'CUSTOMER_READ',
  CUSTOMER_WRITE = 'CUSTOMER_WRITE',
  EVENT_READ = 'EVENT_READ',
  INVOICE_STATEMENT_ACCESS = 'INVOICE_STATEMENT_ACCESS',
  MERCHANT_ADMIN = 'MERCHANT_ADMIN',
  ONBOARD = 'ONBOARD',
  ONBOARD_TEST = 'ONBOARD_TEST',
  ORDER_READ = 'ORDER_READ',
  ORDER_WRITE = 'ORDER_WRITE',
  PAYMENT_READ = 'PAYMENT_READ',
  PAYMENT_WRITE = 'PAYMENT_WRITE',
  PAYOUT_READ = 'PAYOUT_READ',
  PAYOUT_WRITE = 'PAYOUT_WRITE',
  SETTLEMENT_READ = 'SETTLEMENT_READ',
  SUBSCRIPTION_READ = 'SUBSCRIPTION_READ',
  SUBSCRIPTION_WRITE = 'SUBSCRIPTION_WRITE',
  SWISH_PAYOUTS_READ = 'SWISH_PAYOUTS_READ',
  SWISH_PAYOUTS_WRITE = 'SWISH_PAYOUTS_WRITE',
}
